import _ from 'lodash';
import { getCustomCursor } from '@/shared/ui/components/FabricJS/Helper';

export const ANNOTATION_TYPE = {
  HLINE: 'HorizontalCaliper',
  VLINE: 'VerticalCaliper',
  TEXT: 'TextAnnotation',
  BCC: 'BeatComplexCalipers',
  EVENT_POSITION: 'EventPosition',
  SAMPLE_MARK: 'SampleMark',
  RECT_SELECT: 'RectangleSelection',
  PATTERN: 'Pattern',
  BEAT_MARKER: 'BeatMarkers',
  AFIB_EVENT: 'AFibEvent',
  NOISE_EVENT: 'NoiseEvent',
  EVENT_INDICATOR: 'EventIndicator',
  BOOKMARK_INDICATOR: 'BookmarkIndicator',
  BEAT_SAMPLE_MARK: 'BeatSampleMark',
};

export const DEFAULT_FONT = 'Inconsolata, Arial, Helvetica, sans-serif';
export const DEFAULT_FONT_BOLD = '"Inconsolata Bold", Arial, Helvetica, sans-serif';

export const BCC_LABELS = ['P', 'Q', 'R', 'S', 'T', 'R2'];

export const MOUSE_CURSOR = {
  DEFAULT: 'default',
  CROSSHAIR: 'crosshair',
  ZOOM_IN: 'zoom-in',
  POINTER: 'pointer',
  ARROW: 'arrow',
  MOVE: 'move',
  DELETE_BEAT_CURSOR: getCustomCursor(),
};

export const EVENT_STATUSES = {
  NEW: 'New',
  EDITED: 'Edited',
  NEEDS_VERIFICATION: 'Needs Verification',
  APPROVED: 'Approved',
};

export const WIDGET_TYPE = {
  DRAG: 0,
  HORIZONTAL_CALIPER: 1,
  VERTICAL_CALIPER: 2,
  TEXT_ANNOTATION: 3,
  BEAT_COMPLEX_CALIPERS: 4,
  ZOOM: 5,
  SECTION: 6,
  BEAT_REMOVAL: 7,
  EVENT_MARKER: 8,
  EVENT_POSITION: 9,
};

export const WIDGET_UNITS = {
  MILLISECONDS: 'ms',
  MILLIVOLTS: 'mV',
  SECONDS: 's',
  MINUTES: 'min',
};

export const DEFAULT_ECG_VIEWER_CONFIG = {
  spdValue: 25,
  ampValue: 10,
  hiPValue: 1,
  loPValue: 40,
  visibleChannels: [0, 1, 2],
  wndDuration: 10,
  beatTypeNumber: 1,
  isInitialARBeatMode: false,
  originalChannels: ['CH1', 'CH2', 'CH3'],
};

export const ECG_VIEWER_CONFIG_STORE = {
  spdValue: 25,
  ampValue: 10,
  hiPValue: 1,
  loPValue: 40,
  visibleChannels: [0, 1, 2],
  wndDuration: 10,
  beatTypeNumber: 1,
  isInitialARBeatMode: false,
  isInZoomMode: false,
  prevChanIdx: 1,
  beforeZoomValue: null as number | null,
  zoomingChannel: null as number | null,
  isInViewAllMode: false,
  beforeViewAllValue: null as number | null,
};

/**
 * Restores the shared ECG viewer configuration to its defaults, used when a viewer is torn down or reinitialized. Assigns 25 mm/s sweep speed, 10 mm/mV amplitude, a 1Hz to 40Hz filter band, a 10 second window, beat type 1 and the initial-AR-beat flag off, and recomputes visibleChannels by mapping each original channel name's trailing digit to a zero-based index.
 *
 * @returns Nothing.
 */
export const resetEcgViewerConfigStore = () => {
  _.assign(ECG_VIEWER_CONFIG_STORE, {
    spdValue: 25,
    ampValue: 10,
    hiPValue: 1,
    loPValue: 40,
    // ECG_VIEWER_CONFIG_STORE has no `originalChannels` field (only DEFAULT_ECG_VIEWER_CONFIG
    // does) — this always maps over undefined, pre-existing behaviour, not fixed here.
    visibleChannels: _.map(
      (ECG_VIEWER_CONFIG_STORE as any).originalChannels,
      (item: string) => Number(item.slice(-1)) - 1,
    ),
    wndDuration: 10,
    beatTypeNumber: 1,
    isInitialARBeatMode: false,
  });
};

export const TOOLBAR_TYPE = {
  SPEED: 'SPEED',
  GAIN: 'GAIN',
  HIGH_PASS: 'HP',
  LOW_PASS: 'LP',
};

export const CAPTURE_MODE = {
  OTHER: 'OTHER',
  EVENT: 'EVENT',
  ARTIFACT: 'ARTIFACT',
};

export const TYPE_MODE = {
  CAPTURE: 'CAPTURE',
  ADD_BEAT: 'ADD_BEAT',
};
